import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const CustomerList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section>
      <div className="customer-list-warp">
        <div className="inner">
          <div className="customer-example" style={{ marginBottom: 60 }}>
            <div className="customer-img">
              <img
                width="400"
                src={`//files.authing.co/authing-website/customer-list-heigh-educate.png`}
                alt="authing customer"
              />
            </div>
            <div className="customer-content">
              <div className="customer-title">
                {t("customer.home.example.heigh-educate.title")}
              </div>
              <div className="customer-subtitle">
                {t("customer.home.example.heigh-educate.subtitle")}
              </div>
              <div className="customer-label-warp">
                <div
                  className="customer-label"
                  style={{ background: "#8861FF" }}
                >
                  {t("customer.home.example.heigh-educate.label1")}
                </div>
                <div
                  className="customer-label"
                  style={{ background: "#1A66FF" }}
                >
                  B2C
                </div>
              </div>
              <div
                className="customer-button"
                onClick={() => {
                  navigate("/customer/hep");
                }}
              >
                {t("common.button.learn-more")}
              </div>
            </div>
          </div>
          {/* <div className="customer-example">
            <div className="customer-content">
              <div className="customer-title">高等教育出版社 - 传统企业的转型之路</div>
              <div className="customer-subtitle">
                高等教育出版社是中国教育出版传媒集团有限公司的成员单位，是以出版高等教育、职业教育、成人及社会教育等教育类、专业类、科技类出版物为主的综合性大型出版社，本门户网站提供企业资讯、出版图书、数字化产品及课程、教学资源信息。
              </div>
              <div className="customer-button">查看详情</div>
            </div>
            <div className="customer-img">
              <img width="400" src={`//files.authing.co/authing-website/customer-list-futu.png`} alt="" />
            </div>
          </div> */}
        </div>
        <div style={{ margin: "0 auto", width: 1400 }}>
          <div className="customer-list-bg">
            <img
              width="1400px"
              src="//files.authing.co/authing-website/customer-list-bg.png"
              alt="authing list"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
